module.exports = __webpack_public_path__ + "img/hanzo.6ddb6e94.png";